<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-delivery`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31 6a2 2 0 012 2v6h4.702l8.972 8.178a1 1 0 01.326.739V38a2 2 0 01-2 2h-4v1a3 3 0 11-6 0v-1H13v1a3 3 0 11-6 0v-1H3a2 2 0 01-2-2V8a2 2 0 012-2h28zm-2 4H5v26h24V10zm4 8h3.153L43 24.242V36H33V18z"/></svg>
</template>
<script>

export default {
  name: 'IconDelivery',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
